export const generateLogKey = log => {
  let key = log.name
  if (log.level === 'error') key += '_error'
  if (log.level === 'warn') key += '_warn'

  return key
}

export const translateLog = (t, log) => {
  return t(generateLogKey(log), { log, count: log.entities?.length || 1 })
}
